import RelationshipMetadata from "../../RelationshipMetadata";

class ProjectPlanPhaseProjectPlanPhaseAttachmentRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseProjectPlanPhaseAttachment";
        this.parentEnterpriseComponent = "ProjectPlanPhase";
        this.childEnterpriseComponent = "ProjectPlanPhaseAttachment";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ProjectPlanPhaseUSID";
    }
}

export default ProjectPlanPhaseProjectPlanPhaseAttachmentRelationshipMetadata;